import { HitterSide } from '../../enums/hitters.enums';
import {
  MlbSportId,
  PlayerStatusCode,
} from '../../enums/mlb-stats-api/base.enum';
import { PitcherHand } from '../../enums/pitches.enums';
import { HasId } from '../common/i-extensions';
import { IMlbTeamDetails } from '../mlb-stats-api/i-team';

export const DUMMY_SEASON = -1;

export interface IMlbPlayerCoordinate {
  season: number;
  sportId: MlbSportId;
  playerPk: number;
}

export interface IMlbPlayer extends HasId, IMlbPlayerCoordinate {
  name: string;
  pitchHand: PitcherHand;
  batSide: HitterSide;

  // * might be undefined for older seasons if the parser is not re-run
  statusCode: PlayerStatusCode | undefined;

  _mx_details?: IMlbPlayerDetails;
  _mx_team_details?: Partial<IMlbTeamDetails>;
}

// via mixin on the front-end
export interface IMlbPlayerDetails {
  isPitcher: boolean;
  isBatter: boolean;
  isHome: boolean;
}
